// Backend has been observed to return `task_config` as a JSON-encoded string
// instead of a decoded object on some task-type responses. Every reviewer-side
// consumer of `task_config` must defend against both shapes; centralised here
// so the guard doesn't drift between panels.

type TaskConfig = Record<string, unknown> | undefined;

export function parseTaskConfig(raw: unknown): TaskConfig {
  if (raw && typeof raw === "object") return raw as Record<string, unknown>;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object"
        ? (parsed as Record<string, unknown>)
        : undefined;
    } catch {
      return undefined;
    }
  }
  return undefined;
}

export function transitionForms(
  raw: unknown,
): Record<string, string> | undefined {
  const cfg = parseTaskConfig(raw);
  const map = cfg?.transition_forms;
  return map && typeof map === "object"
    ? (map as Record<string, string>)
    : undefined;
}

export function stepForms(
  raw: unknown,
): Record<string, string> | undefined {
  const cfg = parseTaskConfig(raw);
  const map = cfg?.step_forms;
  return map && typeof map === "object"
    ? (map as Record<string, string>)
    : undefined;
}
